import { useState, useEffect } from "react";
import Modal from "../../../../parts/modal-new";
import VideoUpload from "../components/VideoUpload";
import SvgIcon from "../../../../parts/SvgIcon";

const id = "modal-daily-accountability-templates";
const form = "daily-accountability-templates";

const SelectDailyAccountabilityTemplates = ({
  workflow,
  accountabilityWidgets = [],
  explanationAdded,
}) => {
  const [addVideo, setAddVideo] = useState(false);
  useEffect(() => {
    if (explanationAdded) {
      setAddVideo(false);
    }
  }, [explanationAdded]);

  if (!accountabilityWidgets.length) {
    return (
      <Modal
        name={id}
        key={id}
        title="Select Daily Accountability Templates"
        className="getting-started-video"
      >
        <div className="body flex flex-col items-center justify-center pb-6">
          <p className="s2">No Daily Accountability Templates Available</p>
          <p className="p4 mt-4">
            You need to publish a daily accountability template to your widgets
            so it can be linked to this feature
          </p>

          <a
            href="/coaching-portal/widgets?section=learn&learn=daily-accountability-template"
            role="button"
            data-button-type="primary"
            className="mt-12"
          >
            Create New
          </a>
        </div>
      </Modal>
    );
  }

  return (
    <form
      action={
        addVideo
          ? "/actions/getting-started/video"
          : "/actions/getting-started/select-daily-accountability-templates"
      }
      method="POST"
      id={form}
      encType="multipart/form-data"
      data-noreset
    >
      <input type="hidden" name="option" value="accountabilities" />
      <input type="hidden" name="workflow" value={workflow._id} />

      <Modal
        name={id}
        key={id}
        title="Select Daily Accountability Templates"
        className="getting-started-video narrow"
        toClear={["explanationAdded"]}
      >
        <div className="body">
          {addVideo ? (
            <VideoUpload
              form={form}
              video={workflow.options.accountabilities?.video}
              explanationVideo
              goBack={() => setAddVideo(false)}
            />
          ) : (
            <>
              <p className="p5 pb-2">
                Select a daily accountability template that you already have
                published in your widgets. You will need to select or add one in
                order to use this feature
              </p>

              {accountabilityWidgets.map(({ _id, name, description, icon }) => (
                <article
                  key={_id}
                  onClick={() => {
                    document.getElementById(_id)?.click();
                  }}
                >
                  <div className="flex items-center gap-3">
                    <SvgIcon src={`/img/widget-icons/${icon}.svg`} />
                    <div>
                      <p className="s2">{name}</p>
                      <p className="p5 mt-2">{description}</p>
                    </div>
                  </div>
                  <input
                    type="radio"
                    name="value"
                    id={_id}
                    value={_id}
                    defaultChecked={
                      workflow.options.accountabilities?.widget === _id
                    }
                  />
                </article>
              ))}

              <div className="chip info mt-4">
                <span>
                  To add more daily accountability templates, please go to the
                  widget section and create a new one or else click{" "}
                  <a href="/coaching-portal/widgets?section=learn&learn=daily-accountability-template">
                    here
                  </a>{" "}
                  to visit the widget section
                </span>
              </div>
            </>
          )}
        </div>

        <footer className="foot">
          {!addVideo && !explanationAdded && (
            <button
              onClick={() => setAddVideo(true)}
              type="button"
              data-button-type="outline"
              className="mr-auto"
            >
              <span>Add Explanation Video</span>
            </button>
          )}
          <button data-button-type="primary" type="submit">
            {addVideo ? "Add Video" : "Select"}
          </button>
        </footer>
      </Modal>
    </form>
  );
};

export default SelectDailyAccountabilityTemplates;
